export default class NewsAToZ {

    constructor(aToZListContainer) {
        this.fetchDomElements(aToZListContainer);
        this.registerButtonEventListeners();
        this.scrollHelper();
    }

    fetchDomElements(aToZListContainer) {
        this.domElements = {
            aToZListContainer: aToZListContainer,
            loadMoreAToZNewsButton: aToZListContainer.querySelectorAll('.loadMoreAToZNewsButton')[0],
            header: document.getElementById('header'),
        };
    }

    registerButtonEventListeners() {
        if (this.domElements.loadMoreAToZNewsButton) {
            this.domElements.loadMoreAToZNewsButton.addEventListener('click', () => this.onLoadMoreNewsButtonClick());
        }
    }

    onLoadMoreNewsButtonClick() {
        this.domElements.aToZListContainer
            .querySelectorAll('.hidden')
            .forEach((el) => {
                el.classList.remove('hidden');
            });
        ;

        this.domElements.loadMoreAToZNewsButton.style.display = 'none'; 
    }

    scrollHelper() {
        var hash = window.location.hash;
        var that = this;
        if (!hash) return;

        var $el;

        $el = getTabElementByHash(hash);
        if ($el && $el.length > 0) {
            return scrollToTabElement($el);
        }


        $el = getContentElementByHash(hash);
        handleIfElementIsinTab($el);

        if ($el && $el.length > 0) {
            setTimeout(function() {
                scrollToContentElement($el);
            }, 0);
            return;
        }

        //== Functions
        function handleIfElementIsinTab($el) {
            var $tabPane = $el.parents('.tab-pane');
            if ($tabPane.length == 0) return;

            var id = $tabPane.attr('id');
            var $tab = $('[href="#' + id + '"]');

            $tabPane.siblings().removeClass('active show');
            $tabPane.addClass('active show');

            $tab.parent().siblings().children().removeClass('active show');
            $tab.addClass('active show');
        }

        function getContentElementByHash(hash) {
            return $(hash);
        }

        function scrollToContentElement($el) {
            scrollToElement($el);
        }

        function getTabElementByHash(hash) {
            var $tabElement = $(hash);
            if ($tabElement.is(".tab-pane")) {
                return $tabElement;
            }
        }

        function scrollToTabElement($el) {
            var $tab = $('[data-toggle="tab"][href="#' + $el.attr('id') + '"]');
            var $tabNav = $tab.parents('.nav-tabs').first();
            var $tabContent = $el.parent();

            $tabNav.find(".active").removeClass("active");
            $tab.addClass("active");

            $tabContent.find(".active").removeClass("active show");
            $el.addClass("active show");

            scrollToElement($el);
        }

        function scrollToElement($el) {
            var scrollTop = $el.offset().top;
             
            scrollTop -= 15; // just some space between content element and header/breadcrumb
            scrollTop -= that.domElements.header.offsetHeight;

            $('html, body').animate({ scrollTop: scrollTop });
        }
    }
}

